import React, { useEffect } from "react";
import "./Styles/Timeline.css";
import { VerticalTimeline, VerticalTimelineElement } from "react-vertical-timeline-component";
import 'react-vertical-timeline-component/style.min.css';

const Timeline = () => {

    return (
        <div id="Timeline">
            <h2 className="myedutitle"><span className="prof">My</span> Education</h2>
            <VerticalTimeline lineColor="#c4c4c4">
                <VerticalTimelineElement className="vertical-timeline-element--education vertical" iconStyle={{ background: '#2190ff', color: '#fff' }} icon={<i class="fa-solid fa-graduation-cap"></i>}
                    date="92.20 %">
                    <div className="timeline_text">
                        <h2 className="edu_title">SSC</h2>
                        <h3>Ganesh Vidya Mandir</h3>
                        <h4 className="year_place ssc"><span>Kalyan</span><span>2020</span></h4>
                    </div>
                </VerticalTimelineElement>
                <VerticalTimelineElement className="vertical-timeline-element--education vertical" iconStyle={{ background: '#2190ff', color: '#fff' }} icon={<i class="fa-solid fa-graduation-cap"></i>}
                    date="74.50 %">
                    <div className="timeline_text">
                        <h2 className="edu_title">HSC</h2>
                        <h3>Model College of Science & Commerce</h3>
                        <h4 className="year_place"><span>Kalayn</span><span>2022</span></h4>
                    </div>
                </VerticalTimelineElement>

                <VerticalTimelineElement className="vertical-timeline-element--education vertical" iconStyle={{ background: '#2190ff', color: '#fff' }} icon={<i class="fa-solid fa-graduation-cap"></i>}
                    date="CGPA: 9.27">
                    <div className="timeline_text">
                        <h2 className="edu_title" >B.E Information Technology</h2>
                        <h3>VES Institute of Technology</h3>
                        <h4 className="year_place"><span>Mumbai, Maharastra</span><span>2022 - 2026</span></h4>
                    </div>
                </VerticalTimelineElement>
            </VerticalTimeline>
        </div>
    );
};

export default Timeline;